export default class SampleEditFeedbackHandler {
    constructor({ store }) {
        this._store = store;
    }

    async post({ orderId, assignmentId, feedback }) {
        try {
            await this._store.$studentRepository.postSampleEditFeedback(orderId, assignmentId, feedback);
            this._store.$bus.$emit('post_sample_edit_feedback_success');
        } catch (error) {
            this._store.$bus.$emit('post_sample_edit_feedback_error');
        }
    }
}
